import { memo, useEffect, useRef, useState } from "react"
import useStore from "components/ui/Context"
import Link from "next/link"
import { apiSubscription } from "api"
import VlinePlayer from "components/VlinePlayer"
import { QrcodeOnlus } from "components/ui/Icons"
import mqtt from "mqtt"
import { uuid } from "uuidv4"
import { notification } from "components/ui"
const getTracking = () => (typeof window !== "undefined" ? window.TrackingLib : null)

const KEY = {
  SW_ERROR_LINK: 500,
  NOT_LOGIN: 400,
  NOT_TICKET: 402,
  MAX_DEVICES: 411,
  ERROR_LINK: 400,
  SIGN_KEY_INVALID: 401,
  TOKEN_INVALID: 401,
  BLOCK_USER: 403,
  EVENT_FINISH: 300,
  EVENT_UPCOMING: 301,
  ERROR_KPLUS: 423,
  USER_USING_VPN: "user using VPN"
}

function ViewPlay({ initVideo }) {
  // console.log("uuuuuuuuuuuuuuu", initVideo)
  const {
    name,
    thumbnail,
    url,
    is_live,
    is_protected,
    is_timeshift,
    start_time,
    content_id,
    type,
    league_id,
    id,
    link_preventive,
    status,
    skip_ads,
    channel,
    programme_id,
    title,
    channel_title,
    error,
    age,
    content_warning
  } = initVideo
  const { togleModalLogin, userInfo, logOut } = useStore()
  const isLogin = !!userInfo?.fullname
  const [infoVideo, setInfoVideo] = useState({ url: "", signKey: false, errorCode: KEY.NOT_LOGIN, time_interval: 30 })
  const [loading, setLoading] = useState(true)
  const [countViews, setCountViews] = useState(0)
  const indexLink = useRef(0)
  const isError = useRef(0)
  const isMonter = useRef(false)
  const device_id = useRef()
  const client = useRef()
  const __timeOut = useRef()

  function showModalLogin() {
    isMonter.current = true
    togleModalLogin()
  }

  async function checkView() {
    try {
      // await apiSubscription.checkView({ exp: infoVideo?.time_interval || 30 })
    } catch (error) {
      console.log(error)
    }
  }

  async function getSignKey() {
    try {
      const { data } = await apiSubscription.getKey({ match_id: league_id, type, content_id: initVideo?.content_id })
      setInfoVideo((s) => ({ ...s, url, signKey: data?.sign_key, time_interval: data?.time_interval }))
    } catch (e) {
      let er = KEY.SW_ERROR_LINK
      if (e?.response?.status === KEY.NOT_TICKET) er = KEY.NOT_TICKET
      if (e?.response?.status === KEY.MAX_DEVICES) er = KEY.MAX_DEVICES
      if (e?.response?.status === KEY.BLOCK_USER) er = KEY.BLOCK_USER
      if (e?.response?.status === KEY.TOKEN_INVALID) {
        logOut()
        er = KEY.TOKEN_INVALID
      }
      setInfoVideo((s) => ({ ...s, url: "", signKey: false, errorCode: er }))
    } finally {
      setLoading(false)
    }
  }

  const handleError = async (err) => {
    const { errorCode, errorMessage } = err
    if (errorCode === 410) {
      notification.warring({ message: "Bạn vui lòng tắt chặn quảng cáo để trải nghiệm dịch vụ" })
      return
    }
    if (KEY.USER_USING_VPN === errorMessage && infoVideo?.errorCode !== KEY.ERROR_KPLUS && id) {
      setInfoVideo((s) => ({ ...s, url: "", errorCode: KEY.USER_USING_VPN }))
      return
    }
    if (errorCode === KEY.SIGN_KEY_INVALID) {
      if (isError.current < 3) {
        isError.current += 1
        getSignKey()
      }
    } else {
      if (indexLink.current < link_preventive?.length) {
        const __url = link_preventive[indexLink.current]
        setInfoVideo((s) => ({ ...s, url: __url }))
        indexLink.current = indexLink.current + 1
      }
    }
  }

  useEffect(() => {
    if (isMonter.current && isLogin) {
      getSignKey()
    }
    if (isLogin && infoVideo?.time_interval) {
      __timeOut.current = setInterval(() => {
        checkView()
      }, infoVideo?.time_interval * 1000)
    }
  }, [userInfo])

  useEffect(() => {
    device_id.current = "w-" + uuid()
    if (initVideo?.id) {
      if (initVideo?.is_live) initWS()
      if (status === "finish") {
        setLoading(false)
        setInfoVideo((s) => ({ ...s, url: "", signKey: false, errorCode: KEY.EVENT_FINISH }))
      } else if (status === "not_started") {
        setLoading(false)
        setInfoVideo((s) => ({ ...s, url: "", signKey: false, errorCode: KEY.EVENT_UPCOMING }))
      } else {
        if (is_protected) {
          // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
          // let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
          // if (isMobile || isSafari) {
          //   setInfoVideo((s) => ({ ...s, errorCode: KEY.ERROR_KPLUS, url: "" }))
          //   setLoading(false)
          // } else {
          if (isLogin) {
            getSignKey()
          } else {
            setInfoVideo((s) => ({ ...s, url: "", signKey: false, errorCode: KEY.NOT_LOGIN }))
            setLoading(false)
          }
          // }
        } else {
          setInfoVideo((s) => ({ ...s, url, signKey: false }))
          setLoading(false)
        }
      }
    } else {
      if (error?.error_code !== KEY.ERROR_KPLUS)
        setInfoVideo((s) => ({ ...s, url: "", signKey: false, errorCode: KEY.SW_ERROR_LINK }))
    }
    indexLink.current = 0
  }, [initVideo])

  function initWS() {
    const options = {
      clean: false,
      keepalive: 1800,
      protocolVersion: 5,
      reconnectPeriod: 1000,
      connectTimeout: 30000,
      clientId: `web_${device_id.current}`
    }
    const url = process.env.NEXT_PUBLIC_SOCKET
    client.current = mqtt.connect(url, options)
    const toppic = `eventwatch/${initVideo?.id}`
    client.current.on("connect", function () {
      client.current.subscribe(toppic, function (err) {
        if (err) {
          console.log("Error")
        }
      })
    })
    client.current.on("message", (toppic, payload) => {
      const res = JSON.parse(payload.toString())
      setCountViews(res)
    })
  }

  useEffect(() => {
    // console.log("erroerrorerrorerrorr", error)
    if (error?.error_code === KEY.ERROR_KPLUS) {
      console.log(error.error_code)
      setInfoVideo((s) => ({ ...s, errorCode: KEY.ERROR_KPLUS, url: "" }))
      // console.log("initVideo ", initVideo, error)
    }
    if (error?.error_code) setLoading(false)
  }, [error])

  useEffect(() => {
    return () => {
      clearInterval(__timeOut.current)
      __timeOut.current = null
      if (client.current) {
        client.current.unsubscribe(`eventwatch/${initVideo?.id}`)
        client.current.end(true)
      }
    }
  }, [])

  const { errorCode, signKey } = infoVideo
  console.log((!id && !loading) || is_protected)
  return (
    <div>
      <VlinePlayer
        age={age}
        content_warning={content_warning}
        signKey={signKey}
        contentId={content_id}
        src={infoVideo?.url}
        posterUrl={thumbnail}
        isProtected={is_protected}
        isTimeshift={is_timeshift}
        isLive={is_live}
        startTime={start_time}
        name={name}
        id={id}
        type={type}
        skip_ads={skip_ads}
        handleError={handleError}
        countViews={countViews}
        channelId={channel?.id}
        programmeId={programme_id}
        title={title}
        channelTitle={channel_title}
        userInfo={userInfo}
        isChannel={!!channel}
      >
        {!infoVideo?.url && id && !loading && (
          <div className="modal__player">
            <div className="text-center px-2 md:px-0">
              {errorCode === KEY.MAX_DEVICES && (
                <div className="px-8 md:text-xl  text-base font-bold py-2 rounded  text-dark-100">THÔNG BÁO</div>
              )}
              <div className="text-dark-100 mb-4 md:text-base text-sm">
                {errorCode === KEY.MAX_DEVICES && (
                  <div className="w-[600px]">
                    Bạn đã vượt quá giới hạn thiết bị cho phép xem kênh này. <br />
                    Vui lòng tắt kênh đang xem ở các thiết bị khác để tiếp tục
                  </div>
                )}
                {errorCode === KEY.EVENT_FINISH && (
                  <div>
                    Sự kiện đã kết thúc. <br /> Mời quay lại và thưởng thức những nội dung hấp dẫn khác.
                  </div>
                )}
                {errorCode === KEY.EVENT_UPCOMING && (
                  <div>
                    Sự kiện chưa diễn ra. <br /> Mời quay lại và thưởng thức những nội dung hấp dẫn khác.
                  </div>
                )}
                {errorCode === KEY.NOT_TICKET && "Vui lòng đăng ký gói để thưởng thức nội dung này"}
                {errorCode === KEY.NOT_LOGIN && "Vui lòng đăng nhập để thưởng thức nội dung này"}
                {errorCode === KEY.SW_ERROR_LINK && (
                  <div>
                    Rất tiếc, kết nối đến hệ thống tạm thời gián đoạn.
                    <br /> Vui lòng thử lại sau
                  </div>
                )}
              </div>
              {errorCode === KEY.TOKEN_INVALID && (
                <div className="md:text-base text-sm">
                  <div className="mb-4 text-dark-100">Phiên đăng nhập đã hết hạn xin vui lòng đăng nhập lại</div>
                  <button onClick={showModalLogin} className="px-8 text-lg py-2 rounded bg-primary-700 text-dark-100 ">
                    ĐĂNG NHẬP
                  </button>
                </div>
              )}
              {errorCode === KEY.BLOCK_USER && (
                <div className="md:text-base text-sm">
                  <div className="mb-4 text-dark-100 max-w-lg">
                    Tài khoản của bạn đã vi phạm chính sách về bảo vệ bản quyền. Vui lòng liên hệ với tổng đài 19001515
                    để được hỗ trợ
                  </div>
                  <Link href={"/"}>
                    <button className="px-8 text-base py-2 bg-primary-500 text-dark font-medium rounded">
                      Về trang chủ
                    </button>
                  </Link>
                </div>
              )}
              {errorCode === KEY.NOT_TICKET && (
                <Link href={`/subscription?id=${league_id}`}>
                  <button className="px-8 text-base py-2 bg-primary-500 text-dark font-medium rounded">
                    ĐĂNG KÝ GÓI
                  </button>
                </Link>
              )}
              {errorCode === KEY.NOT_LOGIN && (
                <button onClick={showModalLogin} className="px-8 text-lg py-2 rounded bg-primary-700 text-dark-100 ">
                  ĐĂNG NHẬP
                </button>
              )}
              {errorCode === KEY.MAX_DEVICES && (
                <Link href={"/"}>
                  <button className="px-8 text-base py-2 bg-primary-500 text-dark font-medium rounded">ĐÃ HIỂU</button>
                </Link>
              )}
              {errorCode === KEY.USER_USING_VPN && (
                <div className="px-4 py-2 rounded text-center text-dark-100 font-normal md:text-base text-sm">
                  <div>
                    Nội dung hiện chỉ cung cấp trên lãnh thổ Việt Nam <br />
                    Vui lòng liên hệ với đơn vị cung cấp Internet để được hỗ trợ.
                  </div>
                </div>
              )}
              {/* {(errorCode === KEY.ERROR_KPLUS || is_protected) && BLockKPlus} */}
              {errorCode === KEY.ERROR_KPLUS && BLockKPlus}
            </div>
          </div>
        )}

        {/* {((!id && !loading) || is_protected) && ( */}
        {!id && !loading && (
          <div className="modal__player">
            {/* <div className="px-8 text-xl py-2 rounded  text-dark-100">THÔNG BÁO</div> */}
            {/* {errorCode !== KEY.ERROR_KPLUS && !is_protected && ( */}
            {errorCode !== KEY.ERROR_KPLUS && (
              <div className="px-4 py-2 rounded text-center text-dark-100 font-normal md:text-base text-sm">
                <div className="mb-2">Sự kiện đã kết thúc.</div>
                <div>Mời quay lại và thưởng thức những nội dung hấp dẫn khác.</div>
              </div>
            )}
            {/* {(errorCode === KEY.ERROR_KPLUS || is_protected) && BLockKPlus} */}
            {errorCode === KEY.ERROR_KPLUS && BLockKPlus}
          </div>
        )}
      </VlinePlayer>
    </div>
  )
}

export default memo(ViewPlay)

const BLockKPlus = (
  <div>
    <div className="mb-4 text-xs md:text-base max-w-md text-dark-100 text-center">
      Nội dung chưa hỗ trợ xem trên nền tảng / phiên bản này. <br />
      Quý khách vui lòng quét mã QR tải app ON Plus để xem trên điện thoại, máy tính bảng, smartTV.
    </div>
    <div className="flex justify-center">{QrcodeOnlus}</div>
  </div>
)
